import type { StoreApi } from 'zustand';

import type { GameFlowStep } from '../../types/gameFlow';

import {
  shouldInvokeJoinMatchQueue,
  shouldShowGameFlowGlobalLoading,
} from '../../types/matchmaking';

import { GameRoomType } from '../../utils/enums';

import { push, replace } from '../../utils/navigationRef';

import { showAlert } from '../../utils/platform';

import { signalRService } from '../../utils/signalr/signalRService';

import type { GameFlowStore } from '../gameFlowStore';

import { resetCountdownWaitCounter } from './gameFlowTimerState';

import i18n from 'i18next';



let countdownTimer: ReturnType<typeof setInterval> | null = null;



function clearCountdownTimer() {

  if (countdownTimer) {

    clearInterval(countdownTimer);

    countdownTimer = null;

  }

}



function syncGameFlowLoading(store: StoreApi<GameFlowStore>): void {
  const state = store.getState();
  const nextLoading = shouldShowGameFlowGlobalLoading({
    type: state.type,
    step: state.step,
  });

  if (state.isLoading !== nextLoading) {
    store.setState({ isLoading: nextLoading });
  }
}

function navigateToTraderTrainingGame(store: StoreApi<GameFlowStore>) {

  const state = store.getState();

  if (!state.roomId) return;



  void replace('TraderTrainingGame', {

    gameRoomType: state.type,

    gameRoomId: state.roomId,

    interval:

      state.type === GameRoomType.SingleAssign ? state.interval || 2 : 2,

  });

}



function runStepEffect(step: GameFlowStep, store: StoreApi<GameFlowStore>) {

  const state = store.getState();



  if (step !== 'countdown') {

    clearCountdownTimer();

    resetCountdownWaitCounter();

  }



  switch (step) {

    case 'matching':

      if (shouldInvokeJoinMatchQueue(state)) {

        store.getState()._joinMatchQueue();

      }

      break;



    case 'countdown':

      resetCountdownWaitCounter();

      countdownTimer = setInterval(() => {

        store.getState()._tickCountdown();

      }, 1000);

      break;



    case 'sendRoomID':

      if (state.roomId) {

        void store.getState()._sendRoomID();

      }

      break;



    case 'playing':

      navigateToTraderTrainingGame(store);

      break;



    case 'inviteFriendToMatch': {

      const { friendId, type, symbol } = state;

      signalRService.invoke('InviteFriendToMatch', friendId, type, symbol || undefined);

      store.setState({ step: 'waitingInviteID' });

      break;

    }



    case 'receiveFriendInviteCancel':

      store.getState()._clearFriendInviteFlow();

      break;



    case 'rejectFriendInvite': {

      const { inviteID } = state;

      if (inviteID != null) {

        signalRService.invoke('RejectFriendMatch', inviteID).catch(() => {});

      }

      store.getState()._clearFriendInviteFlow();

      break;

    }



    case 'receiveFriendReject':

      showAlert(

        i18n.t('common.errorTitle'),

        i18n.t('matchingModal.friendRejected'),

      );

      store.getState()._clearFriendInviteFlow();

      break;



    case 'acceptFriendInvite':

      signalRService.invoke('AcceptFriendMatch', state.inviteID, undefined);

      store.setState({ step: 'matching', matchID: undefined, matchRole: undefined });

      break;



    case 'acceptFriendInviteAssignStockBattle':

      store.setState({ step: 'acceptFriendInviteAssignStockBattleSelectStock' });

      break;



    case 'dailyStockChallengeInfo':

      push('DailyStockChallengeScreen');

      store.setState({ isLoading: false });

      break;



    case 'startDailyStockChallenge':

      void store.getState()._handleCreateRoom({

        type: GameRoomType.DailyStockChallenge,

        step: 'startDailyStockChallenge',

      });

      break;



    case 'dailyRandomChallengeInfo':

      push('DailyRandomChallengeScreen');

      store.setState({ isLoading: false });

      break;



    case 'startDailyRandomChallenge':

      void store.getState()._handleCreateRoom({

        type: GameRoomType.DailyRandomChallenge,

        step: 'startDailyRandomChallenge',

      });

      break;



    case 'stockRankChallengeScreen':

      push('StockRankChallengeScreen');

      store.setState({ isLoading: false });

      break;



    case 'startStockRankChallenge':

      void store.getState()._handleCreateRoom({

        type: GameRoomType.StockRankChallenge,

        step: 'startStockRankChallenge',

      });

      break;



    default:

      break;

  }



  syncGameFlowLoading(store);

}



export function attachGameFlowEffects(store: StoreApi<GameFlowStore>): void {

  let prevStep = store.getState().step;

  let prevRoomId = store.getState().roomId;



  store.subscribe((state) => {

    const stepChanged = state.step !== prevStep;

    const roomIdChanged = state.roomId !== prevRoomId;



    if (stepChanged) {

      prevStep = state.step;

      runStepEffect(state.step, store);

    } else if (state.step === 'sendRoomID' && roomIdChanged && state.roomId) {

      void store.getState()._sendRoomID();

    } else if (state.step === 'playing' && roomIdChanged) {

      navigateToTraderTrainingGame(store);

    }



    prevRoomId = state.roomId;

    syncGameFlowLoading(store);

  });

}


